// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"638":"1d53d7e1ba8f086c5566","761":"e87fa915945fc1e5069f"}[chunkId] + ".js";
};